import { ResearchSearchBarModel } from '@_types/types';

const searchPageSize = {
  desktop: 9,
  tablet: 6,
  mobile: 3,
};

const researchSearchBarData: ResearchSearchBarModel = {
  search: {
    placeHolder: 'Type "Report" to search',
    searchButton: {
      text: 'Search',
      type: 'submit',
      styleModifier: ['primary', 'large'],
    },
    label: 'Search by name, role or service',
    hasPreIcon: true,
  },
  filterButton: {
    text: 'Open filters',
    type: 'button',
    iconAfter: {
      iconPath: '#kf-filter',
      viewBoxHeight: 24,
      viewBoxWidth: 24,
    },
    styleModifier: ['secondary'],
  },
  filterDrawerId: 'research-filter-drawer',
  searchId: 'research-search',
  searchPageId: '12345',
  pageSize: searchPageSize,
  itemType: 'insights',
  enableExtendedResultsView: true,
  pageLanguage: 'en',
  showWorldwideToggle: true,
  defaultWorldwide: false,
  countrySearchLabel: 'Country',
  worldwideSearchLabel: 'Worldwide',
};

const researchSearchBarWithoutFilterButtonData: ResearchSearchBarModel = {
  search: researchSearchBarData.search,
  searchId: 'research-search',
  pageSize: searchPageSize,
  itemType: 'insights',
  enableExtendedResultsView: true,
  pageLanguage: 'en',
};

const searchBarForSectionSearchBlock: ResearchSearchBarModel = {
  search: researchSearchBarData.search,
  sectionSearchSettings: {
    categories: '1,16,17',
    searchPageUrl: '/pages/search-page/default-research-search-page.html',
  },
  pageLanguage: 'en',
  showWorldwideToggle: true,
  defaultWorldwide: false,
  countrySearchLabel: 'Country',
  worldwideSearchLabel: 'Worldwide',
};

export {
  researchSearchBarData,
  researchSearchBarWithoutFilterButtonData,
  searchPageSize,
  searchBarForSectionSearchBlock as searchBarForSectionSearch,
};
